import { useCallback } from "react";
import { ref, set } from "firebase/database";
import { db } from "../api/firebase";
import { useAuth } from "../helpers/Auth";
import type { Preferences } from "../types";

const usePreferenceActions = () => {
  const { effectiveUID } = useAuth();

  const userPath = () => `/userdata/${effectiveUID}`;

  const editPreferences = useCallback(
    (formProps: Preferences) => {
      set(ref(db, userPath() + `/preferences`), {
        ...formProps,
      });
    },
    [effectiveUID]
  );

  return { editPreferences };
};

export default usePreferenceActions;
